/* #region Welcome */
div.welcomeContainer {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	height: 100%;
	padding-bottom: 1rem;
	width: 100%;

	div.verityTitleWrapper {
		display: flex;
		flex-direction: row;
		gap: 0.3125rem;
		justify-content: center;
		align-items: center;
	}

	h1.verityTitle {
		font-weight: 700;
		font-size: 1.75rem;
		color: #212121;
		line-height: 1.4;
		text-align: center;
	}

	p.welcomeTitle {
		margin-top: -1rem;
		color: #444444;
		font-weight: 600;
		font-size: 1.75rem;
		line-height: 1.4;
	}

	p.welcomeDescription {
		line-height: 1.5;
		font-size: 0.9375rem;
		font-weight: 400;
		color: #333333;
		width: 50vw;
		text-align: center;
	}

	div.imageContainer {
		width: 32vw;
		aspect-ratio: 575/300;
		/*UI teams want button and image to be "center aligned", but it is already center aligned,
        so manually adjusting so visually it looks center aligned*/
		margin-left: 1.5rem;

		svg {
			width: 100%;
			height: 100%;
		}
	}

	button.startCheckButton:global(.MuiButton-root) {
		height: 40px;
		width: fit-content;
		margin-top: 0.9375rem;
		font-size: 0.9375rem;
	}

	div.liveTimerContainer {
		max-width: 240px;
	}

	div.quizInfoContainer {
		display: grid;
		grid-template-columns: max-content 1fr;
		row-gap: 0.75rem;
		column-gap: 1.875rem;

		p.quizLabel {
			color: #333333;
			font-size: 0.9375rem;
			line-height: 1.5;
			font-weight: 600;
		}

		p.quizValue {
			color: #333333;
			font-weight: 400;
			font-size: 0.9375rem;
			line-height: 1.5;
		}
	}
}

@media (max-width: 768px) {
	div.welcomeContainer {
		padding-top: 2rem;

		p.welcomeDescription {
			width: 100%;
		}

		div.imageContainer {
			width: 60vw;
		}

		div.verityTitleWrapper {
			flex-direction: column;
		}
	}
}

/* #endregion */

/* #region System Check */

div.systemCheckSubstep {
	display: flex;
	flex-direction: row;
	gap: 0.625rem;

	div.systemCheckContent {
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
		width: 100%;
	}

	div.systemCheckButtonRow {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		gap: 6.625rem;
		align-items: start;
		width: 100%;
	}

	div.systemMetricsGrid {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 0.625rem;
		margin-top: 0.33rem;
	}

	div.systemMetricsContainer {
		display: flex;
		flex-direction: column;
		gap: 0.3125rem;
		background-color: #f9f9f9;
		max-width: 350px;
		flex: 1 1 200px;
		padding: 0.75rem 0.9375rem;
		justify-content: center;
		border-radius: 4px;
	}

	div.systemMetricsTitleWrapper {
		display: flex;
		flex-direction: row;
		gap: 0.625rem;
		width: 100%;
		align-items: center;
	}

	div.systemMetricsTitleInfoWrapper {
		display: flex;
		flex-direction: row;
		gap: 0.4rem;
		align-items: center;
	}

	div.systemBadge {
		height: 24px;
		min-width: fit-content;
	}

	p.systemMetricsTitle,
	div.systemBadge span {
		color: #565656;
		font-weight: 500;
		font-size: 0.8125rem;
		line-height: 1.6;
	}

	div.systemBadge.failed span {
		color: #994700;
	}

	div.systemBadge.passed span {
		color: #08680b;
	}

	p.systemMetricsValue {
		font-weight: 500;
		font-size: 1.125rem;
		line-height: 1.4;
	}

	button.tryAgainButton:global(.MuiButton-root) {
		height: 36px;
		min-width: 108px;
	}
}

@media (max-width: 480px) {
	div.systemCheckSubstep {
		flex-direction: column;
		justify-content: center;
		align-items: center;

		div.systemMetricsTitleWrapper {
			flex-direction: column;
		}

		div.systemMetricsContainer {
			align-items: center;
		}

		div.systemBadge {
			width: 100%;
		}
	}
}

@media (max-width: 600px) {
	div.systemCheckSubstep {
		flex-direction: column;
		justify-content: center;
		align-items: center;

		div.systemCheckButtonRow {
			justify-content: center;
			flex-direction: column;

			button.tryAgainButton:global(.MuiButton-root) {
				width: 100%;
				min-width: unset;
			}
		}

		div.systemCheckContent {
			align-items: center;
		}

		div.systemMetricsGrid {
			width: 100%;
		}
	}
}

@media (max-width: 900px) {
	div.systemCheckSubstep {
		div.systemCheckButtonRow {
			gap: 1rem;
		}

		div.systemMetricsGrid {
			flex-direction: column;
			height: 100%;
		}

		div.systemMetricsContainer {
			width: 100%;
			max-width: unset;
			flex: unset;
		}
	}
}

/* #endregion */

/* #region Security Check */
div.assessmentSetupButtonWrapper {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;

	button:global(.MuiButton-root) {
		min-width: fit-content;
		width: 140px;
		height: 36px;
	}
}

@media (max-width: 900px) {
	div.assessmentSetupButtonWrapper {
		flex-direction: column;
		justify-content: center;

		button:global(.MuiButton-root) {
			width: 100%;
		}
	}
}

div.restrictedDeviceContainer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	gap: 12.5rem 0.3125rem;
	padding-right: 0.625rem;

	.restrictedDeviceDescription {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	ol.steps {
		display: flex;
		flex-direction: column;
		gap: 10px;
		list-style-type: none;
		padding: 0;
		margin: 0;

		li.step {
			display: flex;
			align-items: start;
			gap: 10px;

			div.stepLabel {
				display: flex;
				align-items: center;
				gap: 5px;

				div.point {
					width: 4px;
					height: 4px;
					background: #2f2f2f;
					border-radius: 50%;
					margin-left: 8px;
					margin-right: 8px;
				}

				div.stepNumber {
					color: #212121;
					font-weight: 600;
				}
			}
		}
	}

	div.qrWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
	}

	.restrictedDeviceQRContainer {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 200px;
		height: 200px;
	}

	.qrCornerTopLeft {
		position: absolute;
		top: 0;
		left: 0;
		width: 24px;
		height: 24px;
		border-top: 8px solid #dae9ed;
		border-left: 8px solid #dae9ed;
		border-radius: 8px 0 0 0;
	}

	.qrCornerTopRight {
		position: absolute;
		top: 0;
		right: 0;
		width: 24px;
		height: 24px;
		border-top: 8px solid #dae9ed;
		border-right: 8px solid #dae9ed;
		border-radius: 0 8px 0 0;
	}

	.qrCornerBottomLeft {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 24px;
		height: 24px;
		border-bottom: 8px solid #dae9ed;
		border-left: 8px solid #dae9ed;
		border-radius: 0 0 0 8px;
	}

	.qrCornerBottomRight {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 24px;
		height: 24px;
		border-bottom: 8px solid #dae9ed;
		border-right: 8px solid #dae9ed;
		border-radius: 0 0 8px 0;
	}

	p.restrictedDeviceQRDescription {
		font-weight: 600;
		font-size: 0.9375rem;
		line-height: 1.5;
		color: #000000;
		text-align: center;
	}

	.qrImage {
		width: 350px;
		height: 220px;
	}
}

@media (max-width: 480px) {
	div.restrictedDeviceContainer {
		flex-direction: column;
		justify-content: center;
		gap: 1rem;
		align-items: center;
		padding: 0;

		button:global(.MuiButton-root) {
			width: 100%;
		}
	}
}

div.blockApplicationWrapper {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;

	div.blockApplicationRowWrapper {
		display: flex;
		flex-direction: row;
		gap: 0.625rem;
		flex-basis: 60%;
	}

	div.blockApplicationTextWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
	}

	ul.blockApplicationList {
		list-style-type: disc;
		margin-left: 1.25rem;
	}

	ul.blockApplicationList li {
		display: list-item;
		padding: 0;
	}

	ul.blockApplicationList li span {
		color: #525252;
		font-size: 0.9375rem;
		font-weight: 400;
		line-height: 1.5;
	}

	button.forceQuit:global(.MuiButton-root) {
		min-width: fit-content;
		width: 226px;
		height: 36px;
	}
}

div.blockedExtensionContainer {
	display: flex;
	flex-direction: row;
	gap: 0.625rem;

	svg {
		flex-shrink: 0;
	}

	div.blockedExtensionWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
	}

	ul.blockExtensionList {
		list-style-type: disc;
		margin-left: 1.25rem;
	}

	ul.blockExtensionList li {
		display: list-item;
		padding: 0.2rem 0;
	}

	ul.blockExtensionList li span {
		color: #525252;
		font-size: 0.9375rem;
		font-weight: 400;
		line-height: 1.5;
	}
}

@media (max-width: 480px) {
	div.blockedExtensionContainer {
		flex-direction: column;
		align-items: center;
	}

	ul.blockExtensionList button {
		text-align: start;
	}
}

/* #endregion */

/* #region Device setup */
div.mediaContainer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	gap: 5rem;

	div.mediaTopRow {
		display: flex;
		flex-direction: row;
		gap: 0.625rem;
		align-items: flex-start;
		width: 100%;
	}

	div.mediaLeftRegion {
		display: flex;
		flex-direction: column;
		gap: 2.1875rem;
		min-width: 0;
	}

	div.mediaHeaderWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.3125rem;
	}

	div.mediaButtonWrapper {
		display: flex;
		flex-direction: row;
		justify-content: end;
		align-items: start;
		flex: 1;
	}

	button.mediaButton {
		width: 200px;
		height: 35px;
	}

	div.videoSelectors {
		display: flex;
		gap: 2.5rem;
		flex-wrap: wrap;
	}

	div.cameraSelector {
		max-width: min(382px, 100%);
		display: flex;
		flex-direction: column;
		align-items: stretch;
		gap: 0.625rem;
	}

	div.videoContainer {
		display: block;
		min-width: 300px;
		aspect-ratio: 640/480;
	}

	div.videoContainer.small {
		width: 300px;
		height: 186px;
		aspect-ratio: 300 / 186;
		flex: unset;
	}

	div.videoContainer.small .videoPreviewContainer {
		aspect-ratio: 300 / 186;
	}

	div.audioWaveContainer {
		display: flex;
		justify-content: center;
		align-items: flex-end;
		flex-direction: column;
		height: 100%;
		gap: 0.625rem;
	}

	div.noAudioWarning {
		display: flex;
		background-color: #fff4ea;
		border-radius: 6px;
		width: 100%;
		padding: 0.625rem;
		justify-content: center;
		align-items: center;
	}

	div.noAudioWarning p {
		color: #b15900;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.5;
	}

	div.videoContainer,
	div.audioWaveContainer {
		margin-right: 1rem;
		min-width: 300px;
		max-width: 400px;
		flex: 1 1 300px;
	}
}

div.screenShareSubstep {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	gap: 5rem;

	button.mediaButton {
		width: 200px;
		height: 35px;
	}
}

div.videoAudioGuide iframe {
	min-width: 300px;
	max-width: 400px;
}

@media (max-width: 1250px) {
	div.mediaContainer div.videoContainer,
	div.mediaContainer div.audioWaveContainer {
		flex: unset;
		min-height: unset;
		max-height: unset;
		min-width: unset;
		max-width: 432px;
		padding-left: 2rem;
		margin-right: unset;
	}

	div.mediaContainer {
		gap: 1rem;
		justify-content: center;
		flex-direction: column;

		div.mediaLeftRegion {
			gap: 1rem;
		}

		div.videoContainer {
			height: unset;
		}

		div.audioWaveContainer {
			width: 100%;
		}
	}
}

@media (max-width: 900px) {
	div.screenShareSubstep {
		justify-content: center;
		flex-direction: column;
		gap: 1rem;

		button:global(.MuiButton-root) {
			width: 100%;
		}
	}

	div.videoAudioGuide {
		flex-direction: column;
		gap: 1rem;

		iframe {
			width: fit-content;
			min-width: unset;
		}
	}
}

@media (max-width: 600px) {
	div.mediaContainer {
		gap: 1rem;
		justify-content: center;
		flex-direction: column;

		div.mediaLeftRegion {
			width: 100%;
			min-width: 0;
		}

		button.mediaButton {
			width: 100%;
		}

		div.videoContainer,
		div.audioWaveContainer {
			min-width: unset;
			max-width: unset;
		}
	}
}

@media (max-width: 480px) {
	div.mediaContainer {
		div.mediaTopRow {
			align-items: center;
			flex-direction: column;
		}

		div.videoContainer,
		div.audioWaveContainer {
			padding-left: unset;
			min-width: unset;
		}
	}
}

.cameraMessage {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	padding: 10px;
}

.cameraMessageText {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	font-size: 14px;
	font-weight: 400;
	text-align: center;
}

.mobileSelectedMessage {
	composes: cameraMessage;
	border-radius: 6px;
	border: 1px solid #dedede;
}

.mobileSelectedImage {
	width: 40px;
	height: 40px;
}

.mobileSelectedText {
	composes: cameraMessageText;
	gap: 5px;
	color: #3e3e3e;
}

.mobileSelectedTitle {
	font-size: 16px;
	font-weight: 600;
	color: #4d4d4d;
}
/* #endregion */

/* #region Room Scan */
div.roomScanWrapper {
	flex-direction: row;
	display: flex;
	gap: 0.5rem;
	width: 100%;

	div.roomScanTopRow {
		display: flex;
		flex-direction: row;
		gap: 0.625rem;
		align-items: flex-start;
		width: 100%;
	}

	div.roomScanLeftRegion {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 0.3125rem;
		padding-right: 4.6rem;
		width: 100%;
	}

	.roomScanDescription {
		margin-bottom: 1.125rem;
	}

	div.roomScanRightRegion {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
		min-height: 0;
		padding-right: 1rem;
	}

	button.roomScanButton:global(.MuiButton-root) {
		height: 46px;
	}

	div.roomScanControlsContainer {
		display: flex;
		flex-direction: row;
		height: 46px;
		border-radius: 6px;
		padding: 0.5rem 1.875rem;
		gap: 1.25rem;
		background-color: #212121;
		justify-content: center;
		align-items: center;
	}

	div.roomScanControlsContainer p {
		color: #fff;
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 1.5;
	}

	div.stopRecordContainer {
		display: flex;
		flex-direction: row;
		gap: 0.3125rem;
		justify-content: center;
		align-items: center;
		padding: 0.125rem;
	}

	button.stopRecording {
		border-radius: 4px;
	}

	button.stopRecording:hover {
		background-color: #525252;
	}

	button.stopRecording:focus-visible {
		outline: 2px solid var(--focus-outline-color-dark);
		outline-offset: 2px;
	}

	.timerText {
		min-width: 50px;
	}

	.roomScanVideo {
		width: 100%;
		object-fit: cover;
		border-radius: 8px;
	}

	div.roomScanProgressBar {
		padding-top: 0.625rem;
		max-width: 400px;
	}
}

div.roomScanRightRegion > :first-child,
.roomScanGuide iframe,
button.roomScanButton:global(.MuiButton-root) {
	min-width: 300px;
	max-width: 400px;
}

@media (max-width: 1250px) {
	div.roomScanWrapper {
		flex-direction: column;

		div.roomScanLeftRegion,
		div.roomScanRightRegion {
			padding-right: unset;
		}
	}
}

@media (max-width: 900px) {
	div.roomScanGuide {
		flex-direction: column;
		gap: 1rem;

		iframe {
			width: fit-content;
			min-width: unset;
		}
	}
}

@media (max-width: 600px) {
	div.roomScanWrapper {
		div.roomScanRightRegion {
			width: 100%;
		}
	}

	div.roomScanRightRegion > :first-child,
	button.roomScanButton:global(.MuiButton-root) {
		min-width: unset;
		max-width: unset;
	}
}

@media (max-width: 480px) {
	div.roomScanWrapper {
		div.roomScanTopRow {
			flex-direction: column;
			align-items: center;
		}
	}
}

/* #endregion */

/* #region Verify Identity */

div.stepProgressLineContainer {
	display: grid;
	width: 100%;
	column-gap: 1.25rem;
	padding-left: 0.3125rem;

	div.stepSegmentContainer {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 100%;
		gap: 0.625rem;
		align-items: flex-start;

		div.stepSegmentBar {
			display: flex;
			width: 100%;
			border-radius: 2px;
			height: 8px;
			background-color: #e4e4e4;
		}

		p.segmentLabel {
			font-size: 0.9375rem;
			line-height: 1.5;
			color: #757575;
			font-weight: 600;
			text-align: center;
		}

		div.labelContainer {
			display: flex;
			flex-direction: row;
			gap: 0.5rem;
			align-items: center;
		}

		div.labelContainer svg {
			flex-shrink: 0;
		}

		&.active {
			div.stepSegmentBar {
				background-color: #6f4fa6;
			}

			p.segmentLabel {
				color: #333333;
			}
		}
	}
}

@media (max-width: 600px) {
	div.stepProgressLineContainer {
		grid-template-columns: 1fr !important;
		row-gap: 1.25rem;

		div.stepSegmentContainer {
			flex-direction: column-reverse;
			justify-content: center;
			align-items: center;
		}
	}
}

div.idVerificationWrapper {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 0.5rem;

	div.idVerificationLeftRegion {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 0.3125rem;
		padding-right: 6rem;
		flex-grow: 1;
	}

	div.idVerificationRightRegion {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
		min-height: 0;
		min-width: 300px;
		max-width: 300px;
	}

	.idVerificationDescription {
		margin-bottom: 1.25rem;
	}

	button.takePhoto:global(.MuiButton-root) {
		min-height: 40px;
	}

	div.flashOverlay {
		position: absolute;
		inset: 0;
		background: white;
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.15s ease-out;
		z-index: 9999;
	}

	div.flashOverlay.active {
		opacity: 1;
	}

	div.cameraOverlayWrapper {
		position: relative;
		width: 100%;
		height: 100%;

		--face-w: 50%;
		--face-h: 80%;

		--id-w: 85%;

		/* Aspect ratio: 3.375 : 2.125 (width : height) */
		--id-h: calc(var(--id-w) * (2.125 / 3.375));
	}

	div.darkCanvas {
		position: absolute;
		inset: 0;
		background-color: rgba(0, 0, 0, 0.5);
		pointer-events: none;
		border-radius: 10px;
		z-index: 2;
	}

	div.darkCanvas.id {
		mask:
			linear-gradient(#000 0 0) content-box,
			linear-gradient(#000 0 0);
		mask-composite: exclude;
		padding: calc((100% - var(--id-h) - 24.5%) / 2) calc((100% - var(--id-w) + 2%) / 2);
	}

	div.idCardOverlayContainer {
		position: absolute;
		width: var(--id-w);
		aspect-ratio: 3.375/2.125;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 3;

		.idTopLeftCorner {
			position: absolute;
			border-radius: 10px 0 0 0;
			width: 32px;
			height: 32px;
			border-left: 4.14px solid #ffffff;
			border-top: 4.14px solid #ffffff;
			top: 0;
			left: 0;
		}

		.idTopRightCorner {
			position: absolute;
			border-radius: 0 10px 0 0;
			width: 32px;
			height: 32px;
			border-right: 4.14px solid #ffffff;
			border-top: 4.14px solid #ffffff;
			top: 0;
			right: 0;
		}

		.idBottomRightCorner {
			position: absolute;
			border-radius: 0 0 10px 0;
			width: 32px;
			height: 32px;
			border-right: 4.14px solid #ffffff;
			border-bottom: 4.14px solid #ffffff;
			bottom: 0;
			right: 0;
		}

		.idBottomLeftCorner {
			position: absolute;
			border-radius: 0 0 0 10px;
			width: 32px;
			height: 32px;
			border-left: 4.14px solid #ffffff;
			border-bottom: 4.14px solid #ffffff;
			bottom: 0;
			left: 0;
		}
	}

	div.darkCanvas.face {
		mask: radial-gradient(
			ellipse calc(var(--face-w) / 2) calc(var(--face-h) / 2) at 50% 50%,
			transparent 99%,
			black 100%
		);
	}

	/* oval for face */

	.faceOverlay {
		position: absolute;
		top: 50%;
		left: 50%;
		width: var(--face-w);
		height: var(--face-h);
		transform: translate(-50%, -50%);
		border: 3.48px solid #ffffff;
		pointer-events: none;
		box-sizing: border-box;
		border-radius: 50%;
		z-index: 3;
	}
}

@media (max-width: 1250px) {
	div.idVerificationWrapper {
		flex-direction: column;

		div.idVerificationLeftRegion {
			padding-right: unset;
		}

		div.idVerificationRightRegion {
			max-width: 400px;
		}
	}
}

@media (max-width: 600px) {
	div.idVerificationWrapper {
		flex-direction: column;

		div.idVerificationRightRegion {
			min-width: unset;
			max-width: unset;
		}
	}
}

div.signatureContainer {
	flex-direction: row;
	width: 100%;
	height: 100%;
	gap: 0.5rem;
	display: flex;

	div.signatureLeftRegion {
		display: flex;
		flex-direction: column;
		gap: 0.3125rem;
		padding-right: 3.125rem;
		width: 100%;

		div.typedSignatureTextField {
			max-width: 400px;
		}

		span.switchMethod {
			margin-top: 3.125rem;

			button:global(.MuiLink-root) {
				vertical-align: baseline;
			}
		}

		&:focus-visible {
			outline: none;
		}
	}

	div.signatureRightRegion {
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
		align-items: flex-end;
		height: 100%;
		min-width: 300px;
		max-width: 400px;

		div.drawContainer {
			padding: 0;
			border: 1px solid #6f6f6f;
			border-radius: 10px;
			width: 100%;
			max-height: 240px;
			aspect-ratio: 4/3;
			position: relative;

			canvas {
				z-index: 2;
				position: relative;
			}
		}

		hr.signaturePlaceholderLine {
			position: absolute;
			top: 85%;
			left: 50%;
			transform: translateX(-50%);
			width: 80%;
			z-index: 1;
			border: 1px solid #919191;
		}

		div.signatureControls {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			width: 100%;
			align-items: center;
			gap: 3.125rem;
		}

		div.signatureOverlay {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 100%;
			height: 100%;
			background-color: transparent;
			transform: translate(-50%, -50%);
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			pointer-events: none;
			gap: 0.5rem;
			text-align: center;
			box-sizing: border-box;
			padding: 0.5rem;
			z-index: 3;

			svg {
				fill: #6f6f6f;
			}
		}

		div.signatureOverlay p {
			color: #333333;
			font-size: 1.125rem;
			font-weight: 400;
			line-height: 1.4;
		}
	}
}

@media (max-width: 900px) {
	div.signatureContainer {
		flex-direction: column;

		div.signatureLeftRegion {
			padding-right: unset;

			span.switchMethod {
				margin-top: 1rem;
			}

			div.typedSignatureTextField {
				width: 100%;
			}
		}
	}
}

@media (max-width: 480px) {
	div.signatureContainer {
		div.signatureRightRegion {
			min-width: unset;
			max-width: unset;
		}
	}
}

div.reviewSubstepContainer {
	position: relative;
	flex-direction: column;
	gap: 1.875rem;

	.attemptsTag {
		position: absolute;
		right: 15px;
		background-color: #fff;
		border-radius: 6px;
		border: 1px solid #e5e5e5;
		padding: 2px 4px;
		width: fit-content;

		.attemptsTagText:global(.MuiTypography-root) {
			font-weight: 500;
			font-size: 14px;
			line-height: 20.8px;
			letter-spacing: 0%;

			color: #004e4e;
		}
	}

	div.reviewPhotoGrid {
		display: flex;
		flex-wrap: wrap;
		width: fit-content;
		max-width: 100%;
		gap: 1.25rem;

		div.reviewPhotoGroup {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			align-items: flex-start;
			gap: 1.25rem;
		}

		div.reviewUnit {
			display: flex;
			flex-direction: column;
			gap: 0.625rem;
		}

		div.reviewPhotoColumns {
			display: flex;
			flex-wrap: wrap;
			gap: 1.25rem;
		}

		div.photoColumn {
			display: flex;
			flex-direction: column;
			gap: 0.625rem;
			width: min(100%, 300px);
			min-width: 250px;
		}

		div.reviewErrorBannerRow {
			display: flex;
			flex-direction: column;
			gap: 0.625rem;
		}

		div.reviewButtonsRow {
			display: flex;
			gap: 1.25rem;
		}

		div.photoContainer {
			position: relative;
			display: inline-block;
			aspect-ratio: 4/3;
			min-width: 250px;
			max-width: 300px;
		}

		div.photoContainer.signature {
			border: 1px solid #919191;
			border-radius: 8px;
		}

		img.photoImage {
			width: 100%;
			display: block;
			object-fit: cover;
			border-radius: 8px;
		}

		.cornerIcon {
			position: absolute;
			top: 12px;
			left: 12px;

			font-size: 24px;
			pointer-events: auto;
		}

		p.photoLabelBadge {
			position: absolute;
			bottom: 12px;
			right: 12px;
			padding: 0.125rem 0.625rem;
			border-radius: 4px;
			background-color: rgba(0, 0, 0, 0.6);
			color: #ffffff;
			font-size: 0.8125rem;
			font-weight: 600;
			line-height: 1.5;
			pointer-events: none;
		}

		button.retakeButton:global(.MuiButton-root) {
			height: 42px;
			width: fit-content;
		}

		div.identityProgress {
			grid-column: span 3;
		}

		div.typedSignatureContainer {
			border-radius: 8px;
			width: 100%;
			justify-content: center;
			align-items: center;
			display: flex;
			text-align: center;
			flex-wrap: wrap;
			border: 1px solid #919191;
			padding: 0.5rem;
		}

		div.typedSignatureContainer p {
			word-break: break-word;
			overflow-wrap: anywhere;
		}
	}
}

@media (max-width: 1200px) {
	div.reviewSubstepContainer {
		div.reviewPhotoGrid {
			width: fit-content;
		}
	}
}

/* #endregion */

/* #region Review */

div.reviewContainer {
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	width: 100%;

	div.reviewTitleWrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 0.5rem;

		p.reviewTitle {
			font-size: 1.75rem;
			font-weight: 600;
			color: #212121;
			line-height: 1.4;
			text-align: center;
		}

		p.reviewDescription {
			color: #333333;
			font-weight: 400;
			font-size: 1.125;
			line-height: 1.4;
		}
	}

	div.reviewSectionWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;

		div.sectionTitleWrapper {
			display: flex;
			flex-direction: row;
			gap: 0.5rem;
			align-items: center;

			h2 {
				font-size: 1rem;
				line-height: 1.4;
				font-weight: 600;
				color: #42296e;
			}

			svg {
				height: 24px;
				width: 24px;
				fill: #5925c8;
			}
		}

		p.reviewSectionDescription {
			color: #333333;
			font-weight: 400;
			font-size: 0.9375rem;
			line-height: 1.5;
		}
	}

	ul.policyList {
		list-style-type: disc;
		margin-left: 1.875rem;
		padding: 0;

		li {
			display: list-item;
			padding: 0;
		}

		li span {
			color: #525252;
			font-size: 0.9375rem;
			font-weight: 400;
			line-height: 1.5;
		}
	}

	div.appliedLimitsContainer {
		border: 1px solid #e7e7e7;
		width: calc(100% - 3rem);
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 2rem;
		row-gap: 1rem;
		border-radius: 10px;
		margin-top: 0.5rem;
		padding: 1.25rem 1.8rem;

		div.appliedLimitItemRow {
			display: flex;
			flex-direction: row;
			gap: 1rem;

			p {
				color: #333333;
				font-weight: 400;
				font-size: 0.9375rem;
				line-height: 1.5;
			}

			svg {
				fill: #42296e;
				width: 24px;
				height: 24px;
			}
		}
	}

	p.allowedUrlText {
		color: #333333;
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 1.5;
		overflow-wrap: anywhere;
	}
}

@media (max-width: 900px) {
	div.reviewContainer {
		div.appliedLimitsContainer {
			width: 100%;
			grid-template-columns: 1fr;
			row-gap: 1.25rem;
		}
	}
}

/* #endregion */

/* #region referenceMaterial */

.referenceMaterialUploadCard {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 1.5rem;
	padding: 1.25rem;
	border: 1px solid #e0e0e0;
	border-radius: 10px;
	background-color: #ffffff;
}

.referenceMaterialUploadGrid {
	display: grid;
	width: fit-content;
	gap: 1.5rem;
}

.referenceMaterialUploadInfo {
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
	flex: 1;
	min-width: 370px;
}

h2.referenceMaterialUploadTitle {
	font-weight: 700;
	font-size: 0.9375rem;
	color: #1a1a1a;

	& .referenceMaterialOptional {
		font-weight: 400;
		color: #757575;
	}
}

p.referenceMaterialUploadCaption {
	font-size: 0.8125rem;
	color: #757575;
}

.referenceMaterialUploadZone {
	flex: 1;
	min-width: 420px;
	display: flex;
	align-items: center;
}

.referenceMaterialUpload {
	width: 100%;
	min-height: 80px;
}

.referenceMaterialUploadZoneContent {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
}

.referenceMaterialUploadError {
	margin-top: 0.125rem;
}

.referenceMaterialFileList {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
}

.referenceMaterialFileItem {
	display: flex;
	width: 100%;
}

.referenceMaterialUploadContent {
	display: flex;
	align-items: center;
	gap: 16px;
}

.referenceMaterialUploadIconCircle {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background-color: #f0ecfc;
	flex-shrink: 0;

	& svg {
		width: 20px;
		height: 20px;

		& path {
			stroke-width: 2;
			stroke: #5f557e;
		}
	}
}

.referenceMaterialUploadActionRow {
	display: flex;
	align-items: center;
	gap: 5px;
	font-size: 15px;
	color: #5d4e79;
}

.referenceMaterialChooseFileLink {
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	color: #0b6f85;
	text-decoration: underline;
	font-size: 15px;
	font-family: inherit;
	border-radius: 2px;

	&:hover {
		text-decoration: none;
	}

	&:focus-visible {
		outline: 2px solid #0b6f85;
		outline-offset: 2px;
	}
}

/* #endregion */
